import {
  CREATE_INDUSTRY_REQUEST,
  CREATE_INDUSTRY_SUCCESS,
  CREATE_INDUSTRY_FAILURE,
  GET_ALL_INDUSTRY_REQUEST,
  GET_ALL_INDUSTRY_SUCCESS,
  GET_ALL_INDUSTRY_FAILURE,
  GET_ONE_INDUSTRY_REQUEST,
  GET_ONE_INDUSTRY_SUCCESS,
  GET_ONE_INDUSTRY_FAILURE,
  EDIT_INDUSTRY_REQUEST,
  EDIT_INDUSTRY_SUCCESS,
  EDIT_INDUSTRY_FAILURE,
  DELETE_INDUSTRY_REQUEST,
  DELETE_INDUSTRY_SUCCESS,
  DELETE_INDUSTRY_FAILURE,
} from "./industryMasterTypes";

// --- GET ALL REDUCER ---
const getAllInitialState = {
  loading: false,
  industryList: [],
  error: "",
};

const getAllIndustryReducer = (state = getAllInitialState, action) => {
  switch (action.type) {
    case GET_ALL_INDUSTRY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_ALL_INDUSTRY_SUCCESS:
      return {
        loading: false,
        industryList: action.payload,
        error: "",
      };
    case GET_ALL_INDUSTRY_FAILURE:
      return {
        loading: false,
        industryList: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

// --- GET ONE REDUCER ---
const getOneInitialState = {
  loading: false,
  industryDetail: {},
  error: "",
};

const getOneIndustryReducer = (state = getOneInitialState, action) => {
  switch (action.type) {
    case GET_ONE_INDUSTRY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_ONE_INDUSTRY_SUCCESS:
      return {
        loading: false,
        industryDetail: action.payload,
        error: "",
      };
    case GET_ONE_INDUSTRY_FAILURE:
      return {
        loading: false,
        industryDetail: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

// --- CREATE REDUCER ---
const createInitialState = {
  loading: false,
  industryData: {},
  error: "",
};

const createIndustryReducer = (state = createInitialState, action) => {
  switch (action.type) {
    case CREATE_INDUSTRY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CREATE_INDUSTRY_SUCCESS:
      return {
        loading: false,
        industryData: action.payload,
        error: "",
      };
    case CREATE_INDUSTRY_FAILURE:
      return {
        loading: false,
        industryData: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

// --- EDIT REDUCER ---
const editInitialState = {
  loading: false,
  industryData: {},
  error: "",
};

const editIndustryReducer = (state = editInitialState, action) => {
  switch (action.type) {
    case EDIT_INDUSTRY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case EDIT_INDUSTRY_SUCCESS:
      return {
        loading: false,
        industryData: action.payload,
        error: "",
      };
    case EDIT_INDUSTRY_FAILURE:
      return {
        loading: false,
        industryData: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

// --- DELETE REDUCER ---
const deleteInitialState = {
  loading: false,
  successData: {},
  error: "",
};

const deleteIndustryReducer = (state = deleteInitialState, action) => {
  switch (action.type) {
    case DELETE_INDUSTRY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_INDUSTRY_SUCCESS:
      return {
        loading: false,
        successData: action.payload,
        error: "",
      };
    case DELETE_INDUSTRY_FAILURE:
      return {
        loading: false,
        successData: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

export {
  getAllIndustryReducer,
  getOneIndustryReducer,
  createIndustryReducer,
  editIndustryReducer,
  deleteIndustryReducer,
};